import CheckboxField, { ICheckboxFieldProps } from './checkbox_field/checkbox_field';

export class PikCheckbox extends CheckboxField {
  public constructor(props: ICheckboxFieldProps) {
    super(props);
  }
}
